/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const NewIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="-1 -1 63 63"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3">
      <circle cx="29.7777778" cy="29.7777778" r="29.3333333" />
      <path d="M29.7777778,13.7777778 L29.7777778,45.7777778" />
      <path d="M45.7777778,29.7777778 L13.7777778,29.7777778" />
    </g>
  </svg>
);

export default NewIcon;
